import { LocationValue } from '@flowwai-frontend/shared/common-components'
import {
   CRMRecordProxyFieldResponseType,
   ShortTextFieldResponseType
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { EntityConfig, MapCoordinates } from '../types'

export const getGeoFieldCRMEntity = (
   entity: EntityConfig | null
): EntityConfig | null => {
   if (!entity) return null

   const getFieldResponseWithTryCatch = (
      fieldId: string
   ): CRMRecordProxyFieldResponseType | undefined => {
      if (!entity) return

      try {
         return entity.getFieldResponse(fieldId)
      } catch (error) {
         return undefined
      }
   }

   const result: EntityConfig | null = entity
      ? {
           entityId: entity.entityId,
           entityType: entity.entityType,
           createOrUpdateFieldResponse: entity.createOrUpdateFieldResponse,
           getFieldResponse: getFieldResponseWithTryCatch
        }
      : null

   return result
}

export const getAddressFieldString = (
   fieldResponseModel: CRMRecordProxyFieldResponseType
): string => {
   const { field } = fieldResponseModel

   switch (field.fieldType) {
      case 'SHORT_TEXT': {
         const result: ShortTextFieldResponseType = fieldResponseModel.response as ShortTextFieldResponseType
         if (!result) return ''

         const resultWithPrefixOrSuffix = `${result.prefix} ${result.value} ${result.suffix}`
         return resultWithPrefixOrSuffix.trim()
      }
      case 'PLAIN_TEXT':
      case 'LONG_TEXT':
      case 'DROPDOWN':
      case 'FIELDS_SELECTOR':
         return fieldResponseModel.response
            ? (fieldResponseModel.response as string)
            : ''
      case 'MULTI_SELECT': {
         const multiItems: string[] = fieldResponseModel.response
            ? (fieldResponseModel.response as string[])
            : []

         return multiItems.join(', ')
      }
      default:
         return ''
   }
}

export const getCoordinatesForGeoShape = (
   geoShape: LocationValue
): MapCoordinates[] => {
   switch (geoShape.type) {
      case 'POINT':
         return geoShape.value ? [geoShape.value] : []
      case 'MULTI_POINT':
      case 'LINE':
         return geoShape.value ?? []
      case 'POLYGON':
         return (geoShape.value ?? []).slice(0, -1)
   }
}
